import type { ClientOptions } from "@/.generated/hey/subscriber-backend/types.gen";
import type { Env } from "@/env-schema";

import { createClient, createConfig } from "@/.generated/hey/subscriber-backend/client";
import { reauthenticateOnSessionExpired } from "@/api/api-utils";
import { retrieveTokenDetailsFromLocalStorage } from "@/lib/helpers/authentication-helper";

export type SubscriberBackendEnv = Pick<Env, "VITE_BACKOFFICE_BASE_URL" | "VITE_VOLTACALL_SERVICE_ID"> & {
  VITE_SUBSCRIBER_BACKEND_BASE_URL: Env["VITE_SUBSCRIBER_BACKEND_BASE_URL"];
};

export function _makeSubscriberBackendSdkClient(env: SubscriberBackendEnv) {
  const client = createClient(
    createConfig<ClientOptions>({
      baseUrl: env.VITE_SUBSCRIBER_BACKEND_BASE_URL,
    }),
  );

  client.interceptors.request.use(authorizeRequest);
  client.interceptors.response.use((response, request) => reauthenticateOnSessionExpired(response, request, env));

  return { client };
}

// Authentication

function authorizeRequest(request: Request): Request {
  const tokenDetails = retrieveTokenDetailsFromLocalStorage();
  if (!tokenDetails) {
    return request;
  }

  request.headers.append("Authorization", `Bearer ${tokenDetails.access_token}`);

  return request;
}
